import { Typography } from '@mui/material'
import Alert from '@mui/material/Alert'
import Button from '@mui/material/Button'
import Grid from '@mui/material/Grid'
import Plus from 'mdi-material-ui/Plus'
import { useEffect, useState } from 'react'
import { apiService } from '../../api/axiosClient'
import Page from '../../components/Page'
import PageHeader from '../../components/page-header'
import Spinner from '../../components/spinner'
import BoxWrapper from '../../styles/BoxWrapper'
import DialogFollowUS from '../../views/followus/DialogFollowUS'
import FollowUSWrapper from '../../views/followus/FollowUSWrapper'


const FollowUSList = () => {
  const [loading, setLoading] = useState(true)
  const [items, setItems] = useState([])
  const [show, setShow] = useState(false)
  const [reload, setReload] = useState(0)

  useEffect(() => {
    const fetchData = async () => {
      const response = await apiService.get('/followus/list')
      const payload = response.data;

      setItems(payload.list)
      setLoading(false)
    }

    fetchData().catch(e => console.error(e));
  }, [reload]);

  return (
    loading ?
    <Spinner/>
    :
    <Page title="FollowUS">
      <Grid container spacing={6}>
        <PageHeader
          title={
            <Typography variant='h5' color='#666CFF'>
              FollowUS 관리
            </Typography>
          }
        />
        <BoxWrapper>
          <Button variant='contained' startIcon={<Plus />} onClick={() => setShow(true)} >등록</Button>
        </BoxWrapper>
        <DialogFollowUS show={show} setShow={setShow} reload={reload} setReload={setReload} />
        <Grid item xs={12}>
          {items.length > 0 ? (
            <FollowUSWrapper items={items} setItems={setItems} />
          ) : (
            <Alert severity='warning'>FollowUS 데이타가 없습니다 — <strong>새로 만들어보세요</strong></Alert>
          )}
        </Grid>
      </Grid>
    </Page>
  )
}

export default FollowUSList